import React, { FC } from 'react'
import { Avatar, Button, Grid, Space, Tag, Tooltip, Typography } from 'antd'
import { InfoCircleFilled, ProfileOutlined, SettingOutlined } from '@ant-design/icons'
import { OrganizationWithPermissions } from 'services'
import { OrganizationRoleEnum } from 'services/types'
import { Link } from 'react-router-dom'

interface HeaderProps {
  info: OrganizationWithPermissions
}

export const CardHeader: FC<HeaderProps> = ({ info }) => {
  const { xs } = Grid.useBreakpoint()

  return (
    <div
      style={{
        width: '100%',
        alignItems: 'center',
        display: 'flex',
        gap: 8
      }}
    >
      <Avatar size={xs ? 'small' : 'default'} src={info.picture_url} />
      <Space size="small">
        <Typography.Text
          strong
          style={{
            margin: 0,
            fontSize: xs ? 14 : 16,
          }}
        >
          {info.name ?? info.account_name}
        </Typography.Text>
        {info.roles.map((role) => (
          <Tag color="blue" key={role.roleName}>
            {role.roleName}{' '}
            <Tooltip title={role.roleDescription || ''}>
              <InfoCircleFilled />
            </Tooltip>
          </Tag>
        ))}
      </Space>
      {info.roles.some((role) => role.roleName === OrganizationRoleEnum.SuperAdmin) && (
        <Link to={`/${info.account_name}?tab=settings`} 
          onClick={(e) => {
            e.stopPropagation()
          }} 
          style={{
            marginLeft: 'auto',
          }}>
          <Tooltip title="Organization Profile">
            <Button
              size={xs ? 'small' : 'middle'}
              type="default"
              aria-label="Org Profile"
              shape="circle"
              icon={
                <ProfileOutlined style={{ fontSize: xs ? 14 : 18 }} />
              }
            />
          </Tooltip>
        </Link>
      )}
    </div>
  )
}
